import React from "react";
import classes from "./DefaultChat.module.css";
const DefaultChat = () => {
  return (
    <div className={classes.defaultChatContainer}>
      <p>Choose a chat to start the conversation</p>
    </div>
  );
};

export default DefaultChat;
